'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  border-radius: 8px;\n\n  ', '\n  overflow: hidden;\n'], ['\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  border-radius: 8px;\n\n  ', '\n  overflow: hidden;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n          background-color: #f74c49;\n        '], ['\n          background-color: #f74c49;\n        ']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['                \n          background-color: white;\n          border-width: 1px;\n          border-style: solid;\n          border-color: #E5E5E5;\n        '], ['                \n          background-color: white;\n          border-width: 1px;\n          border-style: solid;\n          border-color: #E5E5E5;\n        ']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _flex = require('./flex');
var _flex2 = _interopRequireDefault(_flex);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Box = (0, _styledComponents2.default)(_flex2.default)(_templateObject, function (props) {
  return props.type === 'error' ? (0, _styledComponents.css)(_templateObject2) : (0, _styledComponents.css)(_templateObject3);
});
Box.displayName = 'Box';
exports.default = Box;